<template>
  <div v-if="bookId">
    <v-form>
      <v-text-field
        class="search-field mb-0"
        v-model="search"
        @input="debouncedOnChange"
        label="Sök i listan"
        single-line
        hide-details
        prepend-icon="$sl-search"
      />
    </v-form>
    <ul class="ebook-reports">
      <li v-for="(item, index) in reports" :key="index">
        <div
          @click="reportClick(item)"
          class="listItem"
          v-if="item && item.reportDetails && item.reportDetails.length>0"
        >
          <div v-if="item.monthTitle!='0'" class="month">{{ item.monthTitle }}</div>
          <div v-if="item.weekTitle!='0'" class="week subtitle-2">{{ $t('labels.week') }} {{ item.weekTitle }}</div>
          <div class="d-flex justify-space-between">
            <div class="date body-2">{{ item.reportWeekday.substring(0,2) + " " + item.reportDay }}</div>
            <div class="elementcell body-2 d-flex">
              {{ getElementsString(item.reportDetails) }}
              <!-- <div v-for="(i, index) in item.reportDetails" :key="index">
                
                <span v-if="i.subElement && index>0">{{ " ," }} {{ i.subElement.element.name }}</span>
                <span v-else>{{ i.subElement.element.name }}</span>
              </div>-->
            </div>
            <div class="icon">
              <v-icon v-if="item" small :class="`${item.status}`">{{iconsStatus(item.status) }}</v-icon>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <EndlessScroll @fetchMore="listenScroll" />
  </div>
</template>

<script>
import API from '@/services/api.js'
import debounce from 'lodash/debounce'
import {mapGetters} from 'vuex'
import EndlessScroll from '@/components/Common/EndlessScroll'
const SugarDate = require('sugar/date')
const SugarLoc = require('sugar/locales')
import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import concat from 'lodash/concat'
import map from 'lodash/map'

// @group Common
// Styled ActionButton component
export default {
  name: 'ReportsList',
  components: {
    EndlessScroll
  },

  props: {
    // id of the apprentice we want to show the reports
    bookId: {
      type: Number,
      default: null
    },
    personId: {
      type: Number,
      default: -1
    }
  },
  data: () => ({
    search: '',
    reports: [],
    allData: [],
    fullReportsList: [],
    startAt: 0,
    gotAll: false,
    isLoading: false,
    statusClass: '',
    totalRows: null,
    newArr: []
  }),

  created() {
    // Used to call debouncedOnChange on create
    this.debouncedOnChange()
  },

  watch: {
    // watch if id of apprentice changes
    // @arg The argument is a number representing apprentice id
    bookId: function(newVal) {
      if (!newVal) {
        return
      }
      this.debouncedOnChange()
    },
    personId: function(newVal) {
      if (!newVal) {
        return
      }
      this.debouncedOnChange()
    }
  },
  computed: {
    // DebouncedOnChange calles when an input is triggered on the field
    // @arg The argument is a function this.searchChanged
    debouncedOnChange() {
      return debounce(this.searchChanged, 500)
    }
  },
  methods: {
    // searchChanged sets all  the criterias needed for the call comming from search
    // @arg The argument is a function this.searchChanged
    getElementsString(items) {      
      let ret = ''
      ret = items.map(i => (i.subElement && i.subElement.name) ? i.subElement.name : '-').join(', ')      
      return ret
    },
    getReportDate(month, date, index) {
      let ret = month + ' ' + date
      if (index > 0 && this.reports[index - 1].reportDay == date) {
        ret = ''
      }
      return ret
    },
    searchChanged() {
      this.reports = []
      this.allData = []
      this.gotAll = false
      this.startAt = 0
      this.fetchReports(this.search)
    },

    reportClick(item) {
      this.$emit('reportDetailItem', item)      
    },

    //Fetch the list on scroll
    // @arg The argument the length of the reports list from the first call
    listenScroll() {
      if (!this.gotAll) {
        this.fetchReports(this.search)
      }
    },

    // Fetch the list of the reports
    // @arg The argument search and startAt

    fetchReports(search) {
      if (this.bookId > 0 || this.personId > 0) {
        // }
        //- GateKeeper
        if (this.isLoading || this.gotAll) {
          return
        }
        this.isLoading = true
        SugarLoc.Date.setLocale('sv'),
          API.listReports({
            bookId: this.bookId > 0 ? this.bookId : null,
            personId: this.personId > 0 ? this.personId : null,
            startAt: this.startAt,
            sortBy: 'fromDate',
            sortDesc: true,
            search: search,
            pageSize: 50
          })
            .then(response => {
              this.gotAll = response.data.rows.length === 0
              this.isLoading = false

              if (this.startAt === 0) {
                this.newArr = response.data.rows
                this.createReportData()
              } else if (!this.gotAll) {
                this.newArr = concat(this.newArr, response.data.rows)
                this.createReportData()
              }
              this.startAt = this.startAt + response.data.rows.length + 2
            })
            .catch(error => {
              console.log('There was an error:', error.response)
            })
            .finally(() => this.isLoading = false)
      } else {
        return
      }
    },
    createReportData() {
      this.reports = []
      var compMonth
      var compWeek
      var pushMonth
      var pushWeek
      this.newArr.forEach((element, index) => {
        if (element.status != 'draft') {
          var date = element.fromDate
          let weekNum = SugarDate.Date(date).format('{w}').raw
          let monthName = SugarDate.Date(date).format('%B').raw
          if (monthName != compMonth) {
            //get the month title
            compMonth = monthName
            pushMonth = monthName
            compWeek='0'
          } else {
            pushMonth = '0'
          }
          if (weekNum != compWeek) {
            pushWeek = weekNum
            compWeek = weekNum
          } else {
            pushWeek = '0'
          }
          this.reports.push({
            month: SugarDate.Date(date).format('%B').raw,
            year: SugarDate.Date(date).format('%Y').raw,
            monthTitle: pushMonth,
            weekTitle: pushWeek,
            reportDay: SugarDate.Date(date).format('{d}/{M}').raw,
            reportWeekday: SugarDate.Date(date).format('%A').raw,
            reportDetails: element.reportDetails,
            status: element.status,
            BookId: element.bookId,
            id: element.id,
            fromDate: element.fromDate
          })
        }
      })
    },
    // iconsStatus called in template
    // @arg The argument statusName and result is the the icon corresponding to the status name
    iconsStatus(statusName) {
      if (!statusName) {
        return
      }
      if (statusName == 'certified') {
        return '$sl-check2'
      }
      if (statusName == 'certifiedWithChanges') {
        return '$sl-check3'
      }

      if (statusName == 'notCertified') {
        return '$sl-check1'
      }
    }
  }
}
</script>

